<template>
    <div>
        <p class="loading text-center pt-5" v-if="loader.firstLoading">
            <i class="fas fa-spinner fa-spin" style="font-size:2rem"></i>
        </p>

        <div v-else>
            <div v-if="loader.rows.length">

                <base-table type="hover" :data="loader.rows">

                    <template slot="columns">
                        <th width="50px"></th>
                        <th width="120px">{{ $t('xapi.log.time') }}</th>
                        <th width="150px">{{ $t('xapi.log.api') }} / {{ $t('xapi.log.method') }}</th>
                        <th>{{ $t('xapi.log.error') }}</th>
                        <th></th>
                    </template>

                    <template slot-scope="{row}">

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null" 
                            @click="open(row)" 
                            :class="'td-actions' + rowClass(row)"
                        >
                            <div class="index text-warning">
                                {{row.index}}
                            </div>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null" 
                            @click="open(row)"
                            :class="rowClass(row)"
                        >
                            {{ row.timestamp.date }}
                            <br><small class="spaced">{{ row.timestamp.time }}</small>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null" 
                            @click="open(row)"
                            :class="rowClass(row)"
                        >
                            {{ row.api }}
                            <div><small>{{ row.method }}</small></div>
                        </td>

                        <td @mouseover="hovered=row.index"
                            @mouseleave="hovered=null"
                            @click="open(row)"
                            :class="rowClass(row)"
                        >
                            <span class="text-danger" v-if="row.error">
                                {{ row.status }} - {{ row.message }}
                            </span>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null"
                            @click="open(row)"
                            :class="rowClass(row)"
                        >
                            {{ row.count }}
                        </td>

                    </template>
                </base-table>

                <div slot="footer" class="text-center mt-3" v-if="loader.hasMore()">
                    <base-button round type="primary" :loading="loader.nextLoading" @click="loader.nextLoad()">
                        {{ $t('common.load-more') }}
                    </base-button>
                </div>

            </div>
            
            <div v-else>
                <p class="text-center pt-3">{{ $t('xapi.common.search.no-result') }}</p>
            </div>

        </div>

        <portal to="modals">

            <modal class="fullscreen" :title="'#'+index" title-color="warning" v-model="modals.viewer">
                <viewer :log="selected"></viewer>
            </modal>

        </portal>
    </div>
</template>

<script>
    import Viewer from './Viewer'
    import ModalsController from '@trax/classes/ModalsController'
    import moment from 'moment'

    export default {

        components: {
            Viewer
        },

        data() {
            return {
                loader: this.$xapi.loaders.logs,
                filters: this.$xapi.filters.logs,
                modals: new ModalsController('viewer'),
                hovered: null,
                selected: null,
                index: null,
                moment: moment
            }
        },

        created() {
            this.loader.setMapData(this.mapData)
            this.loader.firstLoad()
        },

        methods: {

            mapData(item, index) {
                return {
                    index: index + 1,
                    api: this.api(item),
                    method: item.method,
                    error: item.error,
                    status: this.status(item),
                    message: this.message(item),
                    data: item.data,
                    timestamp: this.timestamp(item),
                    count: this.count(item),
                }
            },

            api(item) {
                return item.api
                    .replace('_', ' ')
                    .replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })
                    + ' API'
            },

            timestamp(item) {
                let moment = this.moment(item.created_at)
                return {
                    date: moment.format('YYYY-MM-DD'),
                    time: moment.format('HH:mm:ss'),
                }
            },

            status(item) {
                if (item.error) {
                    return item.data.response.status
                }
                return ''
            },

            message(item) {
                if (item.error) {
                    return item.data.response.message
                }
                return ''
            },

            count(item) {
                if (item.count) {
                    return item.count
                }
                return ''
            },

            rowClass(row) {
                return row.error ? 'error' : ''
            },

            open(row) {
                if (row.error) {
                    this.selected= row
                    this.index = row.index
                    this.modals.open('viewer')
                }
            }
        }
    }
</script>

<style scoped>

    td.error:hover {
        cursor: pointer;
    }
    td .index {
        width: 30px;
        height: 30px;
        text-align: center;
        padding-top: 5px;
    }

</style>